import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import './App.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount, error) => {
        // only retry on network errors
        if (error?.message === 'Network request failed') return true;
        return false;
      },
      refetchOnReconnect: true,
    },
    mutations: {
      retry: false,
    },
  },
});
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
